import { useRef, useState, useEffect } from 'react';

/**
 * check if the text is truncated
 */
function useIsTruncated() {
  var ref = useRef(null);
  var _useState = useState(false),
    isTruncated = _useState[0],
    setIsTruncated = _useState[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      var _ref = ref.current || {},
        _ref$scrollWidth = _ref.scrollWidth,
        scrollWidth = _ref$scrollWidth === void 0 ? 0 : _ref$scrollWidth,
        _ref$clientWidth = _ref.clientWidth,
        clientWidth = _ref$clientWidth === void 0 ? 0 : _ref$clientWidth;
      setIsTruncated(scrollWidth > clientWidth);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return {
    ref: ref,
    isTruncated: isTruncated
  };
}

export { useIsTruncated };
